import userService from "./userService";

const SAS_SAFETY_MARGIN_MS = 60 * 1000;
const SAS_FALLBACK_TTL_MS = 5 * 60 * 1000;

const SELF = "__self__";

const cached = new Map();
const inFlight = new Map();

function parseExpiry(token) {
  try {
    const se = new URLSearchParams(String(token).replace(/^\?/, "")).get("se");
    const parsed = se ? new Date(se).getTime() : NaN;
    return Number.isFinite(parsed) ? parsed : Date.now() + SAS_FALLBACK_TTL_MS;
  } catch (e) {
    return Date.now() + SAS_FALLBACK_TTL_MS;
  }
}

export function peekImageSasToken(getEntityId) {
  const entry = cached.get(getEntityId || SELF);
  if (!entry || Date.now() >= entry.expiresAt - SAS_SAFETY_MARGIN_MS) return null;
  return entry.token;
}

export function getImageSasTokenSilently(getEntityId) {
  const key = getEntityId || SELF;
  const entry = cached.get(key);

  if (entry && Date.now() < entry.expiresAt - SAS_SAFETY_MARGIN_MS) {
    return Promise.resolve(entry.token);
  }

  const pending = inFlight.get(key);
  if (pending) return pending;

  const request = userService
    .getImageSasToken(getEntityId)
    .then((response) => {
      cached.set(key, {
        token: response.data,
        expiresAt: parseExpiry(response.data),
      });
      return response.data;
    })
    .finally(() => {
      if (inFlight.get(key) === request) inFlight.delete(key);
    });

  inFlight.set(key, request);
  return request;
}

export function refreshImageSasToken(getEntityId, staleToken) {
  const key = getEntityId || SELF;

  const pending = inFlight.get(key);
  if (pending) return pending;

  const entry = cached.get(key);
  if (
    entry &&
    staleToken &&
    entry.token !== staleToken &&
    Date.now() < entry.expiresAt - SAS_SAFETY_MARGIN_MS
  ) {
    return Promise.resolve(entry.token);
  }

  cached.delete(key);
  return getImageSasTokenSilently(getEntityId);
}
